import { render, staticRenderFns } from "./SupplierCandidateOverview.vue?vue&type=template&id=9ccc6274&"
import script from "./SupplierCandidateOverview.vue?vue&type=script&lang=js&"
export * from "./SupplierCandidateOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ccc6274')) {
      api.createRecord('9ccc6274', component.options)
    } else {
      api.reload('9ccc6274', component.options)
    }
    module.hot.accept("./SupplierCandidateOverview.vue?vue&type=template&id=9ccc6274&", function () {
      api.rerender('9ccc6274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/SupplierCandidateOverview.vue"
export default component.exports